/* eslint-disable import/prefer-default-export */
export const ActiveProject = {
  activeProjectRequest: 'ACTIVE_PROJECT_PENDING',
  activeProjectSuccess: 'ACTIVE_PROJECT_SUCCESS',
  activeProjectError: 'ACTIVE_PROJECT_ERROR',

  activeProjectReset: 'ACTIVE_PROJECT_RESET_OLD_PROJECT_DATA',
};
